import { CircularProgress, Stack, Typography } from "@mui/material";

import { imageSource, Strings } from "@app/constants";

import { Filters } from "./filter/filters";
import { ProductListCards } from "./products-lists-cards";
import { ProductsListsContainerProps } from "../types";
import { SortDropdown } from "@app/components";
import { useState } from "react";

const ProductListContainer = ({
  filteredData,
  selectedCardId,
  onSelect,
  onViewDetails,
  isMobile,
  shortsOptions,
  setSortValue,
  sortValue,
  selectedCount,
  handleClear,
  priceRange,
  setPriceRange,
  loading,
}: ProductsListsContainerProps) => {
  const isEmpty = !filteredData || filteredData?.length === 0;

  return (
    <Stack
      sx={{
        flexDirection: { xs: "column", md: "row" },
        height: "80vh",
        overflowY: "hidden",
      }}
    >
      <Stack
        sx={{
          width: { xs: "100%", sm: "100%", md: 285 },
          height: { xs: "auto", md: "99.4%" },
          px: { xs: 2, sm: 2, md: 0 },
        }}
      >
        <Filters
          selectedCount={selectedCount}
          handleClear={handleClear}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
        />
      </Stack>

      <Stack
        sx={{
          flex: 1,
          height: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          mt: 1.4,
        }}
      >
        <Stack sx={{ marginLeft: "auto", marginBottom: 2, mr: 2 }}>
          <SortDropdown
            shortOptions={shortsOptions}
            showShotsBy
            value={sortValue}
            onChange={(values) => {
              setSortValue(values);
            }}
          />
        </Stack>
        {loading ? (
          <Stack
            alignItems="center"
            justifyContent="center"
            flex={1}
            height="60vh"
          >
            <img src={imageSource.loading} width={80} />
            <Typography mt={2} color="text.secondary" fontWeight={500}>
              Loading cars...
            </Typography>
          </Stack>
        ) : isEmpty ? (
          <Stack
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography fontWeight={600}>
              {Strings.productListPage.noProductsFound}
            </Typography>
          </Stack>
        ) : (
          <ProductListCards
            filteredData={filteredData}
            selectedCardId={selectedCardId}
            onSelect={onSelect}
            onViewDetails={onViewDetails}
            isMobile={isMobile}
          />
        )}
      </Stack>
    </Stack>
  );
};

export { ProductListContainer };
